import clsx from 'clsx'
import React from 'react'

import NotificationBellIcon from '../Icons/NotificationBellIcon'
import Styles from './NotificationBell.module.scss'

type Props = {
  count?: number
  className?: string
}

const NotificationBell = React.memo(({ count, className }: Props) => {
  return (
    <div
      className={clsx(Styles.wrapper, className)}
      data-testid="notification-bell">
      <span className={Styles.counter}>{count || 0}</span>
      <NotificationBellIcon />
    </div>
  )
})

NotificationBell.displayName = 'NotificationBell'
export default NotificationBell
